import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';

import DisclaimersModal from './DisclaimersModal';
import LabelAsHTML from './LabelAsHTML';
import { PLEASE_CALL, DETAILS, PER_MONTH } from '../constants/labels';
import { disclaimerDetailsModalEvents } from '../utils/analytics';
import { CaDisclaimer } from './CanadaDisclaimerContent';
import './PricingSummary.scss';

export default class PricingSummary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isModalVisible: false,
			paymentInfo: null
		};
		this.closeModal = this.closeModal.bind(this);
	}

	closeModal() {
		const { widgetName, windowId } = this.props.widgetInfo;
		disclaimerDetailsModalEvents(widgetName, windowId, false);
		this.setState({
			isModalVisible: false
		});
	}

	handleHelpCircleIcon(paymentInfo) {
		const { widgetName, windowId } = this.props.widgetInfo;
		disclaimerDetailsModalEvents(widgetName, windowId, true);
		this.setState({
			isModalVisible: true,
			paymentInfo
		});
	}

	render() {
		const detailsLinkMarkup = (
			<button
				onClick={this.props.viewPriceDetail}
				className="text-link d-block ddc-font-size-xsmall"
			>
				<Common
					render={({ labels }) => {
						return labels.get(DETAILS);
					}}
				/>
			</button>
		);
		const { summary = [] } = this.props;
		const { showStickySidebarLoanLease } = this.props.prefs;
		let body;
		if (summary.length === 0) {
			return null;
		} else if (
			summary.length > 1 &&
			showStickySidebarLoanLease === 'true'
		) {
			body = (
				<div>
					<DisclaimersModal
						isModalVisible={this.state.isModalVisible}
						handleClose={this.closeModal}
						paymentInfo={this.state.paymentInfo}
					/>
					<ul className="pricing-summary list-unstyled d-flex align-items-end justify-items-between mb-4">
						{summary.map(price => {
							const {
								_type,
								isFinalPrice,
								label,
								formatted
							} = price;

							let formattedValue = formatted;

							if (formattedValue === PLEASE_CALL) {
								formattedValue = (
									<Common
										render={({ labels }) => {
											return labels.get(PLEASE_CALL);
										}}
									/>
								);
							}
							const isLoanPayment = _type === 'LOAN';
							const isLeasePayment = _type === 'LEASE';

							const cursorPointerClass = isFinalPrice
								? 'pointer'
								: '';

							let summaryClass = '';

							if (summary.length === 2 && isFinalPrice) {
								summaryClass =
									'summary-price pr-4 mr-4 border-right half-width';
							} else if (
								summary.length === 2 &&
								(isLoanPayment || isLeasePayment)
							) {
								summaryClass = 'mr-4 pr-4 half-width';
							} else if (isFinalPrice) {
								summaryClass =
									'summary-price pr-4 mr-4 border-right third-width';
							} else if (isLoanPayment) {
								summaryClass = 'mr-3 third-width';
							} else if (isLeasePayment) {
								summaryClass = 'mr-4 pr-4 third-width';
							}

							let helpCircleIcon = '';
							if (isLeasePayment || isLoanPayment) {
								helpCircleIcon = (
									<button
										onClick={() =>
											this.handleHelpCircleIcon(price)
										}
										className="btn-link p-0"
									>
										<i className="ddc-icon ddc-icon-help-circle text-muted ddc-icon-size-small d-inline-block pl-1" />
									</button>
								);
							}
							return (
								/* eslint jsx-a11y/click-events-have-key-events: 0, jsx-a11y/no-noninteractive-element-interactions: 0 */
								<li
									onClick={() =>
										isFinalPrice
											? this.props.viewPriceDetail()
											: false
									}
									className={`${summaryClass} ${cursorPointerClass}`}
									key={_type}
								>
									<span className="text-muted d-block text-nowrap">
										<Common
											render={({ labels }) => {
												return (
													<LabelAsHTML
														label={labels.get(
															label
														)}
													/>
												);
											}}
										/>
										{helpCircleIcon}
									</span>
									<strong className="line-height-reset ddc-font-size-large">
										{formattedValue}
									</strong>
									<span className="ddc-font-size-xsmall text-muted d-block line-height-reset">
										{isFinalPrice ? (
											detailsLinkMarkup
										) : (
											<Common
												render={({ labels }) => {
													return labels.get(
														PER_MONTH
													);
												}}
											/>
										)}
									</span>
								</li>
							);
						})}
					</ul>
				</div>
			);
		} else {
			// single item (final price) will get detailed pricing markup
			// summary[0] will always be final price - ref: VCDApricing.js
			const { label, formatted } = summary[0];
			const { dealerAddress } = this.props;

			let formattedValue = formatted;

			if (formattedValue === PLEASE_CALL) {
				formattedValue = (
					<Common
						render={({ labels }) => {
							return labels.get(PLEASE_CALL);
						}}
					/>
				);
			}

			body = (
				<dl
					onClick={this.props.viewPriceDetail}
					className="pricing-detail final-price line-height-condensed pointer mb-4"
				>
					<dt>
						<span dangerouslySetInnerHTML={{ __html: label }} />
						{detailsLinkMarkup}
					</dt>
					<dd className="font-weight-bold ddc-font-size-large">
						{formattedValue}
					</dd>
					<CaDisclaimer dealerAddress={dealerAddress} />
				</dl>
			);
		}
		return body;
	}
}

PricingSummary.propTypes = {
	prefs: PropTypes.shape({
		showStickySidebarLoanLease: PropTypes.string
	}).isRequired,
	summary: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired
		})
	).isRequired,
	viewPriceDetail: PropTypes.func.isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired,
		deviceType: PropTypes.string.isRequired
	}).isRequired,
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	})
};

PricingSummary.defaultProps = {
	dealerAddress: {}
};



// WEBPACK FOOTER //
// ./src/components/PricingSummary.jsx